import { Injectable, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ConfigApi } from '../shared/config-api.model';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ConfigUrlProvider } from '../shared/configurl-provider';

@Injectable()
export class UtilServico {
    public sub: any;
    configApi: ConfigApi;

    constructor(private http: Http,
        private httpClient: HttpClient,
        location: Location,
        private configUrlProvider: ConfigUrlProvider) {
        this.configApi = this.configUrlProvider.getConfigApi();
        this.loadConfig();
    }

    ngOnInit() {
    }

    Get(metodo: string) {
        this.loadConfig();
        return this.http.get(this.sub + metodo, this.jwt())
            .map((res: Response) => res.json());
    }

    Put(metodo: string, dados: any) {
        let body = JSON.stringify(dados);
        return this.http.put(this.sub + metodo, body, this.jwt())
            .map((res: Response) => res.json());
    }

    Post(metodo: string, dados: any) {
        let body = JSON.stringify(dados);
        return this.http.post(this.sub + metodo, body, this.jwt())
            .map((res: Response) => res.json());
    }

    private jwt() {
        let dados = JSON.parse(localStorage.getItem('AcessoAdm'));
        if (dados && dados.token) {
            //console.log(dados.token);
            let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'Content-Type', 'Authorization': 'Bearer ' + dados.token });
            return new RequestOptions({ headers: headers });
        }
    }

    loadConfig() {
        this.sub = `${this.configApi.webApiUrl}/api/Inicial/`;
    }
}



// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/servicos/util.servico.ts